/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */
/**
 * @description Controller to get the selected advisor from url parameters when comming from the Store locatore.
 */
export class ParseUrlParamController {
    constructor() {
        const urlParams = this.getParameters(window.location.search.slice(1));

        // Add selected advisor to local & session storage
        const selectedAdvisor = this.createSelectedAdvisor(urlParams);
        this.addToLocalStorage('selectedAdvisor', selectedAdvisor);
        this.addToSessionStorage('selectedAdvisor', selectedAdvisor);

        // Add ic param to cookies with 1h expiry duration
        this.addToCookies('ic', urlParams.ic, 60 * 60);

        // Add needs param to cookies with 1h expiry duration
        const needsKeys = ['code_action', 'code_campagne', 'libelle_campagne', 'nom_interne_diff', 'utm_campaign', 'utm_medium', 'utm_source', 'utm_term'];
        const needs = this.createObjectByKeys(urlParams, needsKeys);
        if(!this.isEmptyObject(needs)) {
            this.addToCookies('needs', JSON.stringify(needs), 60 * 60);
        }
    }

    /**
     * @description Split url param by '&' and split key=value.
     * Values are URIdecoded to get them without special chars.
     *
     * @param {string} pageURL - Query params.
     * @returns {object} Object of params as key/value.
     */
    getParameters(pageURL) {
        return pageURL.split('&')
            .reduce((result, item) => {
                const [key, value] = item.split('=');
                result[key] = decodeURIComponent(value);
                return result;
            }, {});
    }

    /**
     * @description Create selectedAdvisor object from url params.
     *
     * @param {object} urlParams - Object of params as key/value.
     * @returns {object} SelectedAdvisor as object.
     */
    createSelectedAdvisor(urlParams) {
        const advisorKeys = ['psnidtiers', 'idpointdevente', 'codepostal', 'sour'];
        const selectedAdvisor = this.createObjectByKeys(urlParams, advisorKeys);
        if(selectedAdvisor && Object.keys(selectedAdvisor).length) {
            selectedAdvisor.source = 'StoreLocator';
        }
        return selectedAdvisor;
    }

    addToLocalStorage(ObjectName, ObjectToAdd) {
        if(!this.isEmptyObject(ObjectToAdd)) {
            localStorage.setItem(ObjectName, JSON.stringify(ObjectToAdd));
        }
    }

    addToSessionStorage(ObjectName, ObjectToAdd) {
        if(!this.isEmptyObject(ObjectToAdd)) {
            sessionStorage.setItem(ObjectName, JSON.stringify(ObjectToAdd));
        }
    }

    addToCookies(cookieName, cookieValue, expiryDuration) {
        if(cookieValue) {
            const now = new Date();
            const expireTime = now.getTime() + expiryDuration;
            now.setTime(expireTime);
            document.cookie = `${cookieName}=${cookieValue};expires=${now.toString()};path=/`;
        }
    }

    createObjectByKeys(originObject, targetKeys) {
        return Object.keys(originObject).filter(key => targetKeys.includes(key))
            .reduce((obj, key) => {
                obj[key] = originObject[key];
                return obj;
            }, {});
    }

    isEmptyObject(obj) {
        return !obj || !Object.keys(obj).length;
    }
}
